import api from '../services/api';

export const resolverUrlMidia = (url?: string | null) => {
  if (!url) return '';
  const valor = url.trim();
  if (!valor) return '';
  if (/^(?:https?:\/\/|data:|blob:)/i.test(valor)) return valor;

  const caminho = valor.replace(/\\/g, '/');
  const caminhoCodificado = encodeURI(`/${caminho.replace(/^\/+/, '')}`);
  const base = api.defaults.baseURL || '';
  return /^https?:\/\//i.test(base)
    ? `${new URL(base).origin}${caminhoCodificado}`
    : caminhoCodificado;
};

export const resolverUrlFotoPerfil = (url?: string | null) => {
  if (!url) return '';
  const caminho = url.trim().replace(/\\/g, '/');
  if (!caminho.startsWith('/uploads/perfis/')) return '';
  return resolverUrlMidia(caminho);
};

export const arquivoParaImagemUpload = (arquivo?: File | null): Promise<{ nome: string; tipo: string; conteudo: string } | null> =>
  new Promise((resolve, reject) => {
    if (!arquivo) {
      resolve(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve({ nome: arquivo.name, tipo: arquivo.type, conteudo: String(reader.result || '') });
    reader.onerror = reject;
    reader.readAsDataURL(arquivo);
  });

export const obterErroImagem = (arquivo?: File | null): string | null => {
  if (!arquivo) return null;
  const nome = arquivo.name.toLowerCase();
  const tipoValido = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(arquivo.type);
  const extensaoValida = ['.jpg', '.jpeg', '.png', '.webp'].some((extensao) => nome.endsWith(extensao));
  if (arquivo.size > 2 * 1024 * 1024) return 'Use uma imagem até 2MB.';
  if (!extensaoValida || (arquivo.type && !tipoValido)) return 'Use imagem JPG, JPEG, PNG ou WEBP.';
  return null;
};

export const imagemValida = (arquivo?: File | null) => !obterErroImagem(arquivo);
